import React from "react";

function TotalUsers({ users, onSetActiveTab }) {
  return (
    <div className="flex justify-between items-center mb-6">
      <h2 className="text-xl font-semibold text-gray-900">
        User Management ({users.length} total users)
      </h2>
      <button
        onClick={() => onSetActiveTab("create")}
        className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors"
      >
        Add New User
      </button>
    </div>
  );
}

export default TotalUsers;
